var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeftNewDesign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.733 3.677a1.6 1.6 0 0 0-2.262.001l-7.196 7.204a1.6 1.6 0 0 0 .002 2.263L8.48 20.34a1.6 1.6 0 0 0 2.26-2.263L6.409 13.61l15.2-.008a1.6 1.6 0 1 0-.002-3.2l-15.2.008 4.329-4.47a1.6 1.6 0 0 0-.002-2.263"
})));
export default SvgArrowLeftNewDesign;